import React, { useState, useEffect, useContext } from 'react';
import { useToasts } from 'react-toast-notifications';
import { getConfigData, postConfigData } from '../../../api/Api';
import BreadCrumb from '../../../components/admin/Breadcrumb';
import Header from '../../../components/Header';
import Switch from 'react-switch';
import { useLoadingContext } from '../../../contexts/LoadingContext';
import { ProfileContext } from '../../../contexts/ProfileContext';
import Unauthorized from '../../../components/Unauthorized';

const ConfigurationPage = () => {
  const [seconds, setSeconds] = useState(0);
  const [active, setActive] = useState(false);
  const { addToast } = useToasts();
  const { profile, fetchProfileData, isLoadingProfile } = useContext(ProfileContext);
  const { setLoading } = useLoadingContext();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await getConfigData();
      setActive(response.is_active);
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateSettings = async () => {
    setLoading(true);
    const response = await postConfigData({ isActive: active, seconds });
    setLoading(false);
    addToast('Se cambio la configuracion exitosamente', { appearance: 'success' });
  };

  if (isLoadingProfile) {
    return (
      <div className="section">
        <div className="container has-text-centered">
          <div className="box" style={{ borderRadius: '12px', padding: '3rem' }}>
            <span className="icon is-large has-text-primary">
              <i className="fa fa-spinner fa-pulse fa-3x"></i>
            </span>
            <p className="title is-4 mt-4">Cargando...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      {profile.is_admin ? (
        <div>
          <BreadCrumb activeSection={'Configuración'} />
          
          {/* ✅ SECCIÓN PRINCIPAL MODERNIZADA */}
          <section className="section">
            <div className="container">
              <div className="columns is-centered">
                <div className="column is-8">
                  {/* Header de la sección */}
                  <div 
                    className="box has-text-centered mb-5"
                    style={{
                      borderRadius: '12px',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white',
                      padding: '2rem',
                      margin: '0',
                    }}
                  >
                    <h1 className="title is-3 has-text-white has-text-weight-bold mb-3">
                      <span className="icon-text">
                        <span className="icon is-large mr-5">
                          <i className="fa fa-cogs fa-2x"></i>
                        </span>
                        <span>Configuración del Sistema</span>
                      </span>
                    </h1>
                    <p className="subtitle is-5 has-text-white-ter">
                      Configura las notificaciones por email y los periodos de envío
                    </p>
                  </div>

                  {/* Configuraciones */}
                  <div 
                    className="box"
                    style={{
                      borderRadius: '12px',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                      padding: '2rem',
                    }}
                  >
                    <h4 className="subtitle is-4 has-text-weight-bold mb-4 has-text-primary">
                      <span className="icon-text">
                        <span className="icon mr-2">
                          <i className="fa fa-envelope"></i>
                        </span>
                        <span>Notificaciones por Email</span>
                      </span>
                    </h4>

                    <div className="columns is centered">
                      <div className="column is-6 is-centered">
                        {/* Switch de activación */}
                        <div 
                          className="box has-background-light"
                          style={{
                            borderRadius: '8px',
                            padding: '1.5rem',
                            border: '1px solid #e8e8e8',
                          }}
                        >
                          <div className="field">
                            <label className="label has-text-weight-semibold mb-3">
                              <span className="icon-text">
                                <span className="icon is-small mr-2">
                                  <i className="fa fa-power-off"></i>
                                </span>
                                <span>Estado del Sistema</span>
                              </span>
                            </label>
                            <div className="field is-grouped is-grouped-left">
                              <div className="control">
                                <Switch 
                                  checked={active} 
                                  onChange={() => setActive(!active)}
                                  onColor="#48c78e"
                                  offColor="#f14668"
                                  checkedIcon={
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "100%",
                                        fontSize: 12,
                                        color: "white",
                                        fontWeight: "bold"
                                      }}
                                    >
                                      ON
                                    </div>
                                  }
                                  uncheckedIcon={
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "100%",
                                        fontSize: 12,
                                        color: "white",
                                        fontWeight: "bold"
                                      }}
                                    >
                                      OFF
                                    </div>
                                  }
                                  height={28}
                                  width={56}
                                />
                              </div>
                              <div className="control">
                                <span className={`tag ${active ? 'is-success' : 'is-danger'} is-medium`}>
                                  {active ? 'Activo' : 'Inactivo'}
                                </span>
                              </div>
                            </div>
                            <p className="help has-text-info mt-2">
                              <span className="icon is-small">
                                <i className="fa fa-info-circle"></i>
                              </span>
                              {active ? 'Las notificaciones están habilitadas' : 'Las notificaciones están deshabilitadas'}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="column is-6">
                        {/* Periodo de notificaciones */}
                        <div 
                          className="box has-background-light"
                          style={{
                            borderRadius: '8px',
                            padding: '1.5rem',
                            border: '1px solid #e8e8e8',
                          }}
                        >
                          <div className="field">
                            <label className="label has-text-weight-semibold">
                              <span className="icon-text">
                                <span className="icon is-small mr-2">
                                  <i className="fa fa-clock"></i>
                                </span>
                                <span>Período de Notificaciones</span>
                              </span>
                            </label>
                            <div className="control has-icons-left has-icons-right">
                              <input
                                className="input is-medium"
                                type="number"
                                placeholder="300"
                                value={seconds}
                                onChange={(e) => setSeconds(e.target.value)}
                                style={{ borderRadius: '6px' }}
                                disabled={!active}
                              />
                              <span className="icon is-small is-left">
                                <i className="fa fa-clock"></i>
                              </span>
                              <span className="icon is-small is-right">
                                <i className="fa fa-hashtag"></i>
                              </span>
                            </div>
                            <p className="help has-text-info">
                              <span className="icon is-small">
                                <i className="fa fa-info-circle"></i>
                              </span>
                              Tiempo en segundos entre notificaciones (Ej: 5 minutos = 300 segundos)
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Botón de actualizar */}
                    <div className="has-text-centered mt-5">
                      <button 
                        className="button is-primary is-large is-rounded"
                        onClick={handleUpdateSettings}
                        style={{
                          transition: 'all 0.2s ease',
                          boxShadow: '0 4px 8px rgba(50, 115, 220, 0.3)',
                          minWidth: '200px',
                        }}
                      >
                        <span className="icon">
                          <i className="fa fa-save"></i>
                        </span>
                        <span>Guardar Configuración</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      ) : (
        <Unauthorized />
      )}

      {/* ✅ ESTILOS CSS ADICIONALES */}
      <style jsx>{`
        .button:hover {
          transform: translateY(-1px);
          box-shadow: 0 6px 12px rgba(50, 115, 220, 0.4);
        }

        .box {
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .field .label {
          color: #4a4a4a;
          font-size: 0.9rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }

        .input {
          border-radius: 6px;
          transition: all 0.2s ease;
        }

        .input:focus {
          box-shadow: 0 0 0 3px rgba(50, 115, 220, 0.25);
        }

        .input:disabled {
          background-color: #f5f5f5;
          cursor: not-allowed;
          opacity: 0.7;
        }

        .icon-text {
          align-items: center;
        }

        .help {
          font-size: 0.8rem;
          margin-top: 0.5rem;
        }

        .tag {
          font-weight: 600;
          border-radius: 20px;
        }

        /* Responsive */
        @media screen and (max-width: 768px) {
          .columns {
            margin: 0 !important;
          }

          .column {
            padding: 0.5rem !important;
          }

          .box {
            padding: 1.5rem !important;
          }
        }

        /* Mejoras en la accesibilidad */
        .button:focus,
        .input:focus {
          box-shadow: 0 0 0 3px rgba(50, 115, 220, 0.25);
        }

        /* Animaciones suaves */
        .box,
        .button,
        .input {
          transition: all 0.3s ease;
        }
      `}</style>
    </div>
  );
};

export default ConfigurationPage;